module.exports = __webpack_public_path__ + "img/linkedin.1b18d461.png";